import React from "react";
import Slider from "react-slick";
import { Quote } from "lucide-react";
import "./SuccessStories.css";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const toppers = [
  {
    name: "Anjali Sharma",
    rank: "AIR 1 - UPSC 2024",
    img: "https://images.unsplash.com/photo-1607746882042-944635dfe10e",
    testimonial:
      "The structured curriculum and personalized mentorship helped me stay focused and achieve my dream.",
  },
  {
    name: "Rahul Mehta",
    rank: "AIR 3 - BPSC 2024",
    img: "https://images.unsplash.com/photo-1595152772835-219674b2a8a6",
    testimonial:
      "Test analytics were a game changer. I could track my weaknesses and work on them effectively.",
  },
  {
    name: "Priya Verma",
    rank: "AIR 5 - UPSC 2023",
    img: "https://images.unsplash.com/photo-1544725176-7c40e5a2c9f9",
    testimonial:
      "The faculty’s expertise and guidance throughout the journey were unmatched.",
  },
  {
    name: "Priya Verma",
    rank: "AIR 5 - UPSC 2023",
    img: "https://images.unsplash.com/photo-1544725176-7c40e5a2c9f9",
    testimonial:
      "The faculty’s expertise and guidance throughout the journey were unmatched.",
  },
];

const SuccessStories = () => {
  const settings = {
    dots: true,
    infinite: true,
    speed: 600,
    slidesToShow: 3, // default for large screens
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3500,
    responsive: [
      {
        breakpoint: 768, // up to 768px → mobile
        settings: {
          slidesToShow: 1,
        },
      },
      {
        breakpoint: 1280, // up to 1280px → tablets/small laptops
        settings: {
          slidesToShow: 2,
        },
      },
    ],
  };

  return (
    <section className="success-stories-container">
      <h2 className="success-stories-title">Success Stories & Toppers</h2>
      <p className="success-stories-subtitle">
        Meet our achievers who turned their dreams into reality.
      </p>
      <Slider {...settings}>
        {toppers.map((topper, index) => (
          <div className="success-stories-card" key={index}>
            <div className="success-stories-image-wrapper">
              <img
                src={topper.img}
                alt={topper.name}
                className="success-stories-img"
              />
              <span className="success-stories-rank">{topper.rank}</span>
            </div>
            <div className="success-stories-content">
              <h3 className="success-stories-name">{topper.name}</h3>
              <Quote className="success-stories-quote-icon" />
              <p className="success-stories-testimonial">
                "{topper.testimonial}"
              </p>
            </div>
          </div>
        ))}
      </Slider>
    </section>
  );
};

export default SuccessStories;
